(function($) {
	'use strict';

	var $window = $(window);

	var normalizeTeasers = function()
	{
		var $teasers = $('.layout_latest');
		$teasers.data('normalized', false);
		$teasers.each(function()
		{
			// get the teaser element
			var $teaser = $(this);

			// check if already normalized
			if ($teaser.data('normalized') || $window.width() < 600)
			{
				return true;
			}

			// get siblings
			var $siblings = $teaser.siblings('.layout_latest').addBack().filter(':visible');

			// get the max offset for image
			var maxHeadlineHeight = 0;
			$teaser.css('padding-top', 0);
			$siblings.find('h1,h2,h3').each(function()
			{
				var height = $(this).height();
				if (height > maxHeadlineHeight)
				{
					maxHeadlineHeight = height;
				}
			});

			// process each sibling
			$siblings.each(function()
			{
				// get the sibling
				var $sibling = $(this);

				// get the headline
				var $hl = $sibling.find('h1,h2,h3');

				// set padding
				$sibling.css('padding-top', maxHeadlineHeight - $hl.height())

				// set to normalized
				$sibling.data('normalized', true);
			});
		});
	};

	normalizeTeasers();

	$(window).on('load', normalizeTeasers);
	$(window).on('resize', normalizeTeasers);

})(jQuery);
